(function() {
  console.log('🐞 DEBUG: Scroll Debugger Initialized');

  // Monkey patch preventDefault to log who is calling it
  const originalPreventDefault = Event.prototype.preventDefault;
  Event.prototype.preventDefault = function() {
    if (this.type.startsWith('touch') || this.type === 'wheel' || this.type === 'scroll') {
      console.warn('🚫 preventDefault called on event:', this.type, 'Target:', this.target);
      // Log the stack trace to find the culprit
      console.trace(); 
    }
    return originalPreventDefault.apply(this, arguments);
  };

  function getScrollParent(node) {
    if (node == null) return null;
    if (node === document.body || node === document.documentElement) return window;
    
    const style = getComputedStyle(node);
    const overflowY = style.overflowY;
    const isScrollable = overflowY !== 'visible' && overflowY !== 'hidden';
    
    if (isScrollable && node.scrollHeight > node.clientHeight) {
      return node;
    }
    return getScrollParent(node.parentNode);
  }

  function logTouchInfo(e) {
    const touch = e.touches[0] || e.changedTouches[0];
    const target = document.elementFromPoint(touch.clientX, touch.clientY);
    
    if (!target) return;

    const style = window.getComputedStyle(target);
    const scrollParent = getScrollParent(target);
    
    console.log(`📱 ${e.type} | Target: <${target.tagName.toLowerCase()} class="${target.className}">`);
    console.log(`   📍 Coords: ${touch.clientX.toFixed(0)}, ${touch.clientY.toFixed(0)}`);
    console.log(`   🎨 Touch-action: ${style.touchAction}`);
    console.log(`   🖱️ Pointer-events: ${style.pointerEvents}`);
    console.log(`   📜 Overflow-y: ${style.overflowY}`);
    console.log(`   🏗️ Scroll Parent:`, scrollParent === window ? 'WINDOW' : scrollParent);
  }

  // Add passive global listeners to monitor events without blocking
  const opts = { passive: true, capture: true };
  
  window.addEventListener('touchstart', (e) => {
    console.groupCollapsed(`👆 Touch Start (${e.touches.length})`);
    logTouchInfo(e);
    console.groupEnd();
  }, opts);

  window.addEventListener('touchmove', (e) => {
    // Throttling logs for move to avoid spam, or just log if it seems "stuck"
    // For now, let's log only if we suspect it's stuck? No, user wants comprehensive.
    // We'll log a summary every 10 events or so to avoid crashing the console
    if (!window._tmc) window._tmc = 0;
    window._tmc++;
    if (window._tmc % 20 === 0) {
      console.log(`🔄 Touch Move x20... Last target:`, e.target);
    }
  }, opts);

  window.addEventListener('touchend', (e) => {
    console.log('👋 Touch End');
  }, opts);

  window.addEventListener('scroll', (e) => {
    console.log('📜 Scroll Event fired on', e.target);
  }, opts);

})();
